import APagination from './index.vue';

APagination.install = app => {
  app.component(APagination.name, APagination);
};

export default APagination;
